import { ArrowLeft } from "lucide-react";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import ButtonBase from "@mui/material/ButtonBase";
import Stack from "@mui/material/Stack";

import { useDispatch, useSelector } from "@src/store";
import {
  VivIdeasAction,
  VivIdeasSelector,
} from "@src/store/slices/experienceBuilder/ideas";

import { SIDEBAR_CATEGORIES } from "./categories";

/** Fixed 220px rail: back-to-chat link above the category filter. */
export const IdeaLibrarySidebar = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const category = useSelector(VivIdeasSelector.getCategory);

  const textPrimary = theme.palette.primary.main;
  const textSecondary = theme.palette.secondary.main;
  const neutral = theme.igBackgroundColors.interactive.neutral;

  return (
    <Stack
      spacing={3}
      sx={{
        width: 220,
        flexShrink: 0,
        px: 3,
        py: 4,
        borderRight: `1px solid ${theme.igBorders.core.default}`,
        minHeight: 0,
      }}
    >
      <IgButton
        variant="text"
        size="extraSmall"
        onClick={() => dispatch(VivIdeasAction.closeLibrary())}
        // A global `.lucide { color: #4a4a4a }` (App.css) forces every lucide
        // icon gray; override it so the arrow follows the button's colour, as
        // the empty state's link does.
        sx={{
          alignSelf: "flex-start",
          gap: 2,
          px: 0,
          minWidth: 0,
          color: textPrimary,
          "& .lucide": { color: "inherit" },
          "&:hover": { backgroundColor: "transparent" },
        }}
      >
        <ArrowLeft size={16} />
        <IgTypography variant="body2" fontWeight={600} color="inherit">
          Back to chat
        </IgTypography>
      </IgButton>

      <Stack sx={{ overflowY: "auto", minHeight: 0 }}>
        <IgTypography
          variant="body3"
          sx={{
            px: 2,
            py: 2,
            fontWeight: 600,
            textTransform: "uppercase",
            color: theme.palette.text.placeholder,
          }}
        >
          Onsite edits
        </IgTypography>
        {SIDEBAR_CATEGORIES.map((c) => {
          const active = category === c.id;
          return (
            <ButtonBase
              key={c.id}
              onClick={() => dispatch(VivIdeasAction.setCategory(c.id))}
              sx={{
                justifyContent: "flex-start",
                p: 2,
                borderRadius: "6px",
                color: active ? textPrimary : textSecondary,
                backgroundColor: active ? neutral.active : "transparent",
                "&:hover": {
                  backgroundColor: neutral.hover,
                  color: textPrimary,
                },
              }}
            >
              <IgTypography
                variant="body2"
                fontWeight={active ? 600 : 400}
                color="inherit"
              >
                {c.label}
              </IgTypography>
            </ButtonBase>
          );
        })}
      </Stack>
    </Stack>
  );
};
